/* Adapt Dew product page: gallery, photo viewer, colour -> photo sync, sticky offset, pill nav.
   Rebuilt 2026-10-05. Replaces assets/adapt-scrollpin-gallery.js on the product page.

   Design rules for this file:
   - No "desktop vs mobile mode" decided once at load. The layout switch is pure CSS (1000px), and the few places
     that need to know the screen size ask matchMedia at the moment they run.
   - Nothing writes inline heights. The only thing written to the page is the CSS variable --ad-pg-stick. */
(function () {
  'use strict';

  var mq = window.matchMedia('(min-width: 1000px)');
  function onMqChange(fn) {
    if (mq.addEventListener) mq.addEventListener('change', fn);
    else if (mq.addListener) mq.addListener(fn);
  }

  var track = null;

  function trackPad() {
    return track ? (parseFloat(getComputedStyle(track).paddingLeft) || 0) : 0;
  }

  /* ---------- Gallery: dots + counter for the swipe row (phones, tablets) ---------- */
  function setupGallery() {
    var gallery = document.querySelector('[data-pg]');
    if (!gallery) return;
    track = gallery.querySelector('[data-pg-track]');
    if (!track) return;
    var slides = [].slice.call(track.children);
    var dotsWrap = gallery.querySelector('[data-pg-dots]');
    var countEl = gallery.querySelector('[data-pg-count]');
    if (slides.length < 2) {
      var bar = gallery.querySelector('[data-pg-bar]');
      if (bar) bar.hidden = true;
      return;
    }
    var dots = [];
    slides.forEach(function (s, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ad-pg__dot' + (i === 0 ? ' is-on' : '');
      b.setAttribute('aria-label', 'Show photo ' + (i + 1));
      b.addEventListener('click', function () {
        track.scrollTo({ left: s.offsetLeft - trackPad(), behavior: 'smooth' });
      });
      dotsWrap.appendChild(b);
      dots.push(b);
    });
    if (countEl) countEl.textContent = '1 / ' + slides.length;

    var tick = false;
    function update() {
      var left = track.scrollLeft + trackPad();
      var best = 0;
      var bestDist = Infinity;
      slides.forEach(function (s, i) {
        var d = Math.abs(s.offsetLeft - left);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      dots.forEach(function (d, i) { d.classList.toggle('is-on', i === best); });
      if (countEl) countEl.textContent = (best + 1) + ' / ' + slides.length;
      tick = false;
    }
    track.addEventListener('scroll', function () {
      if (tick) return;
      tick = true;
      requestAnimationFrame(update);
    }, { passive: true });
  }

  /* ---------- Photo viewer: every photo opens large, with arrows, swipe and a counter ---------- */
  function setupViewer() {
    var dlg = document.querySelector('[data-pg-dlg]');
    if (!dlg || typeof dlg.showModal !== 'function') return;
    var opens = [].slice.call(document.querySelectorAll('[data-pg-open]'));
    if (!opens.length) return;
    var img = dlg.querySelector('[data-pg-lbimg]');
    var count = dlg.querySelector('[data-pg-lbcount]');
    var cur = 0;
    var last = null;

    function show(i) {
      cur = (i + opens.length) % opens.length;
      var o = opens[cur];
      img.src = o.getAttribute('data-full');
      img.alt = o.getAttribute('data-alt') || '';
      count.textContent = (cur + 1) + ' / ' + opens.length;
    }

    opens.forEach(function (o, i) {
      o.addEventListener('click', function () {
        last = o;
        show(i);
        dlg.showModal();
        document.documentElement.style.overflow = 'hidden';
      });
    });

    dlg.querySelector('[data-pg-lbprev]').addEventListener('click', function () { show(cur - 1); });
    dlg.querySelector('[data-pg-lbnext]').addEventListener('click', function () { show(cur + 1); });

    dlg.addEventListener('click', function (e) {
      if (e.target.closest('[data-pg-close]') || !e.target.closest('.ad-pg__lbInner')) {
        if (dlg.open) dlg.close();
      }
    });
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') show(cur + 1);
      else if (e.key === 'ArrowLeft') show(cur - 1);
    });

    var sx = null;
    var sy = null;
    img.addEventListener('touchstart', function (e) {
      var t = e.changedTouches[0];
      sx = t.clientX;
      sy = t.clientY;
    }, { passive: true });
    img.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var t = e.changedTouches[0];
      var dx = t.clientX - sx;
      var dy = t.clientY - sy;
      sx = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) show(cur + (dx < 0 ? 1 : -1));
    }, { passive: true });

    dlg.addEventListener('close', function () {
      document.documentElement.style.overflow = '';
      img.removeAttribute('src');
      if (last) last.focus();
    });
  }

  /* ---------- Colour -> photo: called by the buy box when a colour swatch is tapped ---------- */
  var hlTimer = null;
  window.adaptPdpFocusMedia = function (mediaId) {
    if (!track || !mediaId) return;
    var slide = track.querySelector('[data-media-id="' + mediaId + '"]');
    if (!slide) return;
    if (mq.matches) {
      var r = slide.getBoundingClientRect();
      if (r.top < 80 || r.bottom > window.innerHeight - 40) {
        slide.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    } else {
      track.scrollTo({ left: slide.offsetLeft - trackPad(), behavior: 'smooth' });
    }
    [].forEach.call(track.querySelectorAll('.is-hl'), function (n) { n.classList.remove('is-hl'); });
    slide.classList.add('is-hl');
    clearTimeout(hlTimer);
    hlTimer = setTimeout(function () { slide.classList.remove('is-hl'); }, 1600);
  };

  /* ---------- Sticky info column: set one CSS variable from real measurements ---------- */
  function setupSticky() {
    var info = document.querySelector('[data-pg-info]');
    if (!info) return;
    function apply() {
      if (!mq.matches) {
        info.style.removeProperty('--ad-pg-stick');
        return;
      }
      var header = document.querySelector('#header-component');
      var headerH = header ? header.getBoundingClientRect().height : 100;
      var wanted = Math.round(headerH + 16);
      /* If the column is taller than the screen, a negative top lets the bottom of it (the add-to-cart) stay in view. */
      var stick = Math.min(wanted, window.innerHeight - info.offsetHeight - 24);
      info.style.setProperty('--ad-pg-stick', stick + 'px');
    }
    apply();
    window.addEventListener('resize', apply);
    window.addEventListener('load', apply);
    onMqChange(apply);
    if ('ResizeObserver' in window) {
      new ResizeObserver(apply).observe(info);
    }
  }

  /* ---------- Pill nav: native anchor links + floating twin + active highlight (same as before) ---------- */
  function setupPillNav() {
    var staticNav = document.querySelector('[data-scrollpin-pill]');
    if (!staticNav) return;

    var floatingWrap = document.createElement('div');
    floatingWrap.className = 'ad-scrollpin-floatingWrap';
    floatingWrap.appendChild(staticNav.cloneNode(true));
    document.body.appendChild(floatingWrap);
    var floatingNav = floatingWrap.querySelector('[data-scrollpin-pill]');

    var staticLinks = [].slice.call(staticNav.querySelectorAll('a[data-nav-item]'));
    var floatingLinks = [].slice.call(floatingNav.querySelectorAll('a[data-nav-item]'));

    function setActive(key) {
      staticLinks.forEach(function (a) { a.classList.toggle('is-active', a.getAttribute('data-nav-item') === key); });
      floatingLinks.forEach(function (a) { a.classList.toggle('is-active', a.getAttribute('data-nav-item') === key); });
    }

    if ('IntersectionObserver' in window) {
      var visibilityObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var fullyPassed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
          floatingWrap.classList.toggle('is-visible', fullyPassed);
        });
      }, { threshold: 0 });
      visibilityObserver.observe(staticNav);
    }

    var sections = {
      testimonials: document.getElementById('pdp-anchor-testimonials'),
      benefits: document.getElementById('pdp-anchor-benefits'),
      faq: document.getElementById('pdp-anchor-faq')
    };
    if ('IntersectionObserver' in window) {
      var activeObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) setActive(entry.target.id.replace('pdp-anchor-', ''));
        });
      }, { rootMargin: '-110px 0px -70% 0px', threshold: 0 });
      Object.keys(sections).forEach(function (key) {
        if (sections[key]) activeObserver.observe(sections[key]);
      });
    }
    setActive('testimonials');
  }

  /* ---------- Hide the floating pill while a drawer, cart or search overlay is open ---------- */
  function setupFloatingPillSuppression() {
    function isAnyOverlayOpen() {
      return !!document.querySelector(
        'details[open][id*="menu-drawer" i], ' +
        'details[open][id*="drawer" i], ' +
        'theme-drawer[open], ' +
        'dialog[open], ' +
        '[data-search-modal][open], ' +
        '.search-modal.is-open, ' +
        '.menu-drawer.is-open'
      );
    }
    function refresh() {
      var suppress = isAnyOverlayOpen();
      [].forEach.call(document.querySelectorAll('.ad-scrollpin-floatingWrap'), function (w) {
        w.classList.toggle('is-suppressed', suppress);
      });
    }
    document.addEventListener('toggle', refresh, true);
    document.addEventListener('click', function () { setTimeout(refresh, 50); }, true);
    if ('MutationObserver' in window) {
      new MutationObserver(refresh).observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['open', 'class'],
        subtree: true
      });
    }
    refresh();
  }

  function init() {
    try { setupGallery(); } catch (e) { console.error('adapt-pdp-gallery: gallery', e); }
    try { setupViewer(); } catch (e) { console.error('adapt-pdp-gallery: viewer', e); }
    try { setupSticky(); } catch (e) { console.error('adapt-pdp-gallery: sticky', e); }
    try { setupPillNav(); } catch (e) { console.error('adapt-pdp-gallery: pill nav', e); }
    try { setupFloatingPillSuppression(); } catch (e) { console.error('adapt-pdp-gallery: overlay suppression', e); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
